import { render, staticRenderFns } from "./course_num.vue?vue&type=template&id=2ab0bb0f&scoped=true"
import script from "./course_num.vue?vue&type=script&lang=js"
export * from "./course_num.vue?vue&type=script&lang=js"
import style0 from "./course_num.vue?vue&type=style&index=0&id=2ab0bb0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0bb0f",
  null
  
)

export default component.exports